import { createI18n } from 'vue-i18n'

import de from '@/locales/de.json'
import en from '@/locales/en.json'
import it from '@/locales/it.json'
import { ElectionLocale } from '@/types'

export type MessageSchema = typeof de
export type TranslationKey = keyof MessageSchema

export const availableLanguages: ElectionLocale[] = ['de', 'it', 'en']

export default createI18n<[MessageSchema], 'de'|'it'|'en'>({
  legacy: false,
  locale: 'de', //TODO navigator.language.split('-')[0],
  fallbackLocale: 'de',
  messages: {
    de,
    it,
    en
  }
})
